export * from './lib/avatar.component.module';
